import React from "react";
import ReactDOM from "react-dom";
import "./preloader.css";
import { useEffect } from "react";
import video from "../../assets/preloader.mp4";

const Preloader = ({ onFinish }) => {
  useEffect(() => {
    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";

    return () => {
      document.documentElement.style.overflow = "auto";
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <div className="preloader">
      <video
        className="preloader-video"
        autoPlay
        muted
        playsInline
        onEnded={onFinish}
      >
        <source src={video} type="video/mp4" />
      </video>
    </div>
  );
};

export default Preloader;